import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { union } from "lodash";
import { Reminder } from "src/app/models/Reminder";

import { AuthService } from "./../../services/auth.service";
import { ReminderService } from "./../../services/reminder.service";

@Component({
  selector: "email-select",
  templateUrl: "./email-select.component.html",
  styleUrls: ["./email-select.component.scss"],
  standalone: false,
})
export class EmailSelectComponent implements OnInit {
  @Input() reminder: Reminder;
  @Input() selectedItems: string;
  @Input() skipItemsLoad = false;
  @Input() valid: boolean = true;
  @Output() selectionChange: EventEmitter<string> = new EventEmitter<string>();

  emailInput: string;
  isLoading: boolean;
  selectedItemsList: string[] = [];
  items: string[] = [];
  newReminder: boolean;

  constructor(
    private reminderService: ReminderService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    if (!this.reminder?.companyId) {
      return;
    }

    this.newReminder = !this.reminder?.id;
    this.initializeSelectedItems();

    if (!this.skipItemsLoad) {
      this.setItemsList();
    } else {
      this.items = [...this.selectedItemsList];
    }
  }

  private initializeSelectedItems() {
    if (this.selectedItems?.trim()) {
      this.selectedItemsList = this.selectedItems.split("; ");
    } else {
      this.selectedItemsList = [];
    }
  }

  setItemsList() {
    this.isLoading = true;
    this.reminderService.getEmailsByCompany(this.reminder.companyId).subscribe((response) => {
      this.isLoading = false;

      // Set default emails for new reminder
      if (this.newReminder) {
        if (this.authService.user?.isUserGroupProfile)
          this.selectedItemsList = [this.authService.user.email];
        else this.selectedItemsList = response;
        this.onSelectionChange();
      }

      this.items = union(response, this.selectedItemsList);
    });
  }

  onSelectionChange() {
    this.selectedItems = this.selectedItemsList.join("; ");
    this.selectionChange.emit(this.selectedItems);
  }

  onAddEmail() {
    if (!this.emailInput) return;
    if (this.selectedItemsList.some((x) => x == this.emailInput)) return;

    this.selectedItemsList = [...this.selectedItemsList, this.emailInput];
    this.items = this.items.some((x) => x === this.emailInput)
      ? this.items
      : [...this.items, this.emailInput];

    this.emailInput = "";

    this.onSelectionChange();
  }

  onSelectAll() {
    this.selectedItemsList = this.items;
    this.onSelectionChange();
  }

  onClearAll() {
    this.selectedItemsList = [];
    this.onSelectionChange();
  }
}
